/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { HealthProLight } from './HealthProLight';
import {
    HealthProLightFromJSON,
    HealthProLightFromJSONTyped,
    HealthProLightToJSON,
    HealthProLightToJSONTyped,
} from './HealthProLight';
import type { PhoneNumber } from './PhoneNumber';
import {
    PhoneNumberFromJSON,
    PhoneNumberFromJSONTyped,
    PhoneNumberToJSON,
    PhoneNumberToJSONTyped,
} from './PhoneNumber';

/**
 * Institute with its attached health professionals
 * @export
 * @interface Institute
 */
export interface Institute {
    /**
     * the unique identifier of the institute
     * @type {string}
     * @memberof Institute
     */
    id: string;
    /**
     * the name of the institute
     * @type {string}
     * @memberof Institute
     */
    name: string;
    /**
     * the short name of the institute
     * @type {string}
     * @memberof Institute
     */
    shortName: string;
    /**
     * 
     * @type {Address}
     * @memberof Institute
     */
    address: Address;
    /**
     * 
     * @type {string}
     * @memberof Institute
     */
    email?: string;
    /**
     * 
     * @type {PhoneNumber}
     * @memberof Institute
     */
    phoneNumber?: PhoneNumber;
    /**
     * 
     * @type {Array<HealthProLight>}
     * @memberof Institute
     */
    healthPros?: Array<HealthProLight>;
}

/**
 * Check if a given object implements the Institute interface.
 */
export function instanceOfInstitute(value: object): value is Institute {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('shortName' in value) || value['shortName'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function InstituteFromJSON(json: any): Institute {
    return InstituteFromJSONTyped(json, false);
}

export function InstituteFromJSONTyped(json: any, ignoreDiscriminator: boolean): Institute {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'shortName': json['shortName'],
        'address': AddressFromJSON(json['address']),
        'email': json['email'] == null ? undefined : json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : PhoneNumberFromJSON(json['phoneNumber']),
        'healthPros': json['healthPros'] == null ? undefined : ((json['healthPros'] as Array<any>).map(HealthProLightFromJSON)),
    };
}

export function InstituteToJSON(json: any): Institute {
    return InstituteToJSONTyped(json, false);
}

export function InstituteToJSONTyped(value?: Institute | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'shortName': value['shortName'],
        'address': AddressToJSON(value['address']),
        'email': value['email'],
        'phoneNumber': PhoneNumberToJSON(value['phoneNumber']),
        'healthPros': value['healthPros'] == null ? undefined : ((value['healthPros'] as Array<any>).map(HealthProLightToJSON)),
    };
}

